<div
  class="flex min-h-screen items-center justify-center bg-gray-100 px-4 py-10 selection:bg-indigo-100 selection:text-gray-900"
  [@fadeInOut]>
  <div class="relative w-full max-w-[420px] rounded-xl border border-gray-200 bg-white px-8 py-8 sm:px-10">
    <div *ngIf="loading"
      class="absolute inset-0 z-10 flex items-center justify-center rounded-xl bg-white/90"
      [@fadeInOut]>
      <div class="flex flex-col items-center">
        <div class="h-10 w-10 animate-spin rounded-full border-2 border-gray-200 border-b-black [animation-duration:600ms]"></div>
        <p class="mt-4 text-sm text-gray-600">Signing in...</p>
      </div>
    </div>

    <div class="flex flex-col items-center text-center">
      <img class="h-16 w-auto" src="/assets/Buziflow-Logo750.gif" alt="BuziFlow" />
      <p class="mt-3 text-base font-medium leading-6 text-gray-700">Workflow-Centric Communication</p>
    </div>

    <div class="mt-6 border-t border-gray-200"></div>

    <h1 class="mt-6 text-xl font-semibold tracking-tight text-gray-900">Sign in</h1>

    <form (ngSubmit)="login()" class="mt-5 space-y-4">
      <div>
        <label for="email" class="block text-sm font-medium text-gray-900">Email address</label>
        <input [(ngModel)]="email" (ngModelChange)="clearEmailError()" id="email" name="email" type="email" autocomplete="email" required
          placeholder="name@company.com"
          [attr.aria-invalid]="emailInvalid"
          [attr.aria-describedby]="emailInvalid ? 'email-error' : null"
          class="mt-1.5 block w-full rounded-lg border-gray-300 text-sm text-gray-900 caret-indigo-600 placeholder:text-gray-500 focus:border-indigo-500 focus:ring-indigo-500"
          [class.border-red-600]="emailInvalid"
          [class.focus:border-red-600]="emailInvalid"
          [class.focus:ring-red-600]="emailInvalid">
        <p *ngIf="emailInvalid" id="email-error" class="mt-1 text-sm text-red-700">Please enter a valid email address.</p>
      </div>

      <div>
        <label for="password" class="block text-sm font-medium text-gray-900">Password</label>
        <div class="relative mt-1.5">
          <input [(ngModel)]="password" (ngModelChange)="clearPasswordError()" [type]="showPassword ? 'text' : 'password'" id="password" name="password" autocomplete="current-password" required
            [attr.aria-invalid]="passwordInvalid"
            [attr.aria-describedby]="passwordInvalid ? 'password-error' : null"
            class="block w-full rounded-lg border-gray-300 pr-11 text-sm text-gray-900 caret-indigo-600 placeholder:text-gray-500 focus:border-indigo-500 focus:ring-indigo-500"
            [class.border-red-600]="passwordInvalid"
            [class.focus:border-red-600]="passwordInvalid"
            [class.focus:ring-red-600]="passwordInvalid">
          <button type="button" (click)="togglePasswordVisibility()" [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
            matTooltip="{{ showPassword ? 'Hide password' : 'Show password' }}"
            matTooltipPosition="above"
            class="absolute inset-y-0 right-0 flex w-11 items-center justify-center rounded-md text-gray-600 transition-transform duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:text-gray-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 active:scale-[0.97]">
            <svg *ngIf="!showPassword" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
              <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            <svg *ngIf="showPassword" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
            </svg>
          </button>
        </div>
        <p *ngIf="passwordInvalid" id="password-error" class="mt-1 text-sm text-red-700">Password is required.</p>
      </div>

      <p *ngIf="credentialsInvalid" id="credentials-error" role="alert" class="text-sm text-red-700">
        Login failed. Check the email and password, then try again.
      </p>

      <button type="submit" [disabled]="loading || !email || !password"
        class="mt-2 h-11 w-full rounded-lg bg-black text-sm font-semibold text-white transition-[transform,background-color] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:bg-gray-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 active:scale-[0.97] disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-600 disabled:active:scale-100">
        <span *ngIf="!loading">Sign in</span>
        <span *ngIf="loading">Signing in...</span>
      </button>
    </form>

    <p class="mt-5 text-center text-sm text-gray-600">Version {{ version }}</p>
  </div>
</div>
